var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmex = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 32,
  fill: "none",
  viewBox: "0 0 46 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F72CD",
  d: "M0 4a4 4 0 0 1 4-4h38a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m8.127 11.333-4.241 9.663h5.077l.63-1.54h1.439l.63 1.54h5.588V19.82l.498 1.176h2.891l.498-1.201v1.2h11.624l1.413-1.5 1.324 1.5 5.97.013-4.255-4.816 4.255-4.859h-5.877l-1.376 1.473-1.282-1.473H20.288l-1.086 2.494-1.111-2.494h-5.067v1.136l-.564-1.136zm.983 1.372h2.475l2.813 6.553v-6.553h2.712l2.172 4.698 2.003-4.698h2.698v6.934h-1.642l-.013-5.433-2.393 5.433h-1.469l-2.406-5.433v5.433h-3.377l-.64-1.555h-3.46l-.638 1.553h-1.81zm23.05 0h-6.675v6.93h6.571l2.119-2.297 2.041 2.297h2.134l-3.102-3.445 3.102-3.485H36.31l-2.108 2.27zM10.314 13.88l-1.14 2.769h2.278zm16.82 1.528V14.14h4.164l1.817 2.024-1.897 2.035h-4.085v-1.382h3.642v-1.41z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmex);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/amex.48d3afd094d1bf935c9dfbf94fae1a24.svg";